<ion-header>
    <ion-toolbar>
        <ion-title>Swap Out</ion-title>
        <ion-buttons slot="start">
            <ion-button (click)="modalController.dismiss()">
                <ion-icon slot="icon-only" name="arrow-back"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-buttons slot="end">
            <ion-button (click)="scanCode()">
                <ion-icon slot="icon-only" name="barcode"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content>

    <datepicker [document]="documentTemp"></datepicker>
    <location-select [document]="documentTemp"></location-select>
    <customer [document]="documentTemp"></customer>
    <site [document]="documentTemp"></site>
    <comments [document]="documentTemp"></comments>
    <ion-item>
        <ion-input [(ngModel)]="manualInput" placeholder="Manual barcode input"></ion-input>
        <ion-button slot="end" (click)="handleScanResult(manualInput)" [disabled]="!manualInput" color="light">
            <ion-icon slot="icon-only" name="add"></ion-icon>
        </ion-button>
    </ion-item>


    <ion-list *ngIf="brokenEquipment || replacementEquipment">
        <ion-item *ngIf="brokenEquipment">
            <ion-label>
                <p>Broken Equipment</p>
                <p>{{brokenEquipment.description}}</p>
                <p>{{brokenEquipment.pdesc}} | {{brokenEquipment.reg}}</p>
            </ion-label>
        </ion-item>
        <ion-item *ngIf="replacementEquipment">
            <ion-label>
                <p>Replaced by Equipment</p>
                <p>{{replacementEquipment.description}}</p>
                <p>{{replacementEquipment.pdesc}} | {{replacementEquipment.reg}}</p>
            </ion-label>
        </ion-item>
    </ion-list>

    <ion-fab vertical="bottom" horizontal="end" slot="fixed">
        <ion-fab-button (click)="saveChangeover()" color="success">
            <ion-icon name="checkmark"></ion-icon>
        </ion-fab-button>
    </ion-fab>

</ion-content>
